import {
  CC_PREFIX_PATH,
  TrafficOriginType,
} from '@cc-shopping/contracts/credit-cards-page/constants';
import { ORGANIC_SLUG_COPIES } from 'src/shared/roundup/pm-config';
import { BaggageIcon } from './Icons/BaggageIcon';
import { BalanceTransferIcon } from './Icons/BalanceTransferIcon';
import { GiftIcon } from './Icons/GiftIcon';
import { LockIcon } from './Icons/LockIcon';
import { MoneyBagIcon } from './Icons/MoneyBagIcon';
import { StarIcon } from './Icons/StarIcon';
import { StudentIcon } from './Icons/StudentIcon';
import { ZeroPercentIcon } from './Icons/ZeroPercentIcon';
import type { MainSubnavItemType, SubnavItemType } from './types';

const PAID_SLUG_SET = new Set<string | undefined>(ORGANIC_SLUG_COPIES);
const ORGANIC_ROOT = CC_PREFIX_PATH.Organic;
const PAID_ROOT = CC_PREFIX_PATH.Paid;

function toPaidRelativePath(href: string): string {
  // early return for base URL
  if (href === ORGANIC_ROOT) return PAID_ROOT;

  // check any sub-paths
  if (href.startsWith(ORGANIC_ROOT)) {
    const slug = href.replace(`${ORGANIC_ROOT}/`, ''); // account for `/`
    if (PAID_SLUG_SET.has(slug)) return `${PAID_ROOT}/${slug}`;
  }
  return href;
}

export function getNavItemsForTrafficOrigin<T extends SubnavItemType | MainSubnavItemType>(
  items: T[],
  trafficOriginType: TrafficOriginType,
): T[] {
  if (trafficOriginType === TrafficOriginType.Organic) return items;
  return items.map(item => ({ ...item, href: toPaidRelativePath(item.href) }));
}

export const getIcon = (type: string) => {
  switch (type) {
    case 'StarIcon':
      return StarIcon;
    case 'MoneyBagIcon':
      return MoneyBagIcon;
    case 'BalanceTransferIcon':
      return BalanceTransferIcon;
    case 'BaggageIcon':
      return BaggageIcon;
    case 'ZeroPercentIcon':
      return ZeroPercentIcon;
    case 'GiftIcon':
      return GiftIcon;
    case 'StudentIcon':
      return StudentIcon;
    case 'LockIcon':
      return LockIcon;
    default:
      return StarIcon;
  }
};
